import {
  Panel,
  PanelHeader,
  PanelHeaderBack,
} from '@vkontakte/vkui';

import styles from './index.module.css';
import { DesktopAfterUserChooseProps } from './types';
import { useRouter } from '../../../../hooks/useRouter';
import { AfterUserChoosePage } from '../../pages/AfterUserChoosePage';

export const DesktopAfterUserChoosePanel: React.FC<DesktopAfterUserChooseProps> = ({ id }) => {
  const router = useRouter();
  const  onBackClick = router.back;

  return (
    <Panel id={id} className={styles.panel}>
      <PanelHeader before={<PanelHeaderBack onClick={onBackClick}/>}>
              AI-профориентатор
      </PanelHeader>
      <AfterUserChoosePage/>
    </Panel>);
};
